
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3565",
  depVersions: {
  "customer-portal-app": "static-1.3565",
  "apollo-dlb": "static-3.98",
  "avatar-components": "static-1.3028",
  "client-types": "static-1.524",
  "data-fetching-client": "static-1.10176",
  "emoji-mart": "static-3.10",
  "enviro": "static-4.529",
  "growth-payments-core": "static-1.26635",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6132",
  "hs-test-utils": "static-1.8583",
  "hub-http": "static-1.6745",
  "hub-http-shared-msw-handlers": "static-1.11009",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19409",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12030",
  "I18n": "static-7.1725",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6998",
  "payment-link-components": "static-1.24593",
  "portals-platform-bend-plugin": "static-1.30",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7765",
  "quartz-core": "static-1.6984",
  "quartz-i18n": "static-1.1440",
  "react": "static-7.206",
  "react-colorpicker": "static-2.10749",
  "react-dlb": "static-1.97",
  "react-utils": "static-2.5719",
  "reselect": "static-3.20",
  "rich-text-lib": "static-1.20650",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18611",
  "ui-components-test-utils": "static-1.6167",
  "UIComponents": "static-3.8976",
  "video-player-core": "static-1.24",
  "foundations-assets": "static-1.5430",
  "foundations-components": "static-1.8853",
  "foundations-theming": "static-1.5041",
  "foundations-theming-specialty": "static-1.2757",
  "framer-motion": "static-1.87",
  "hs-browser-apis": "static-1.18",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.459",
  "portals-platform-lib": "static-1.1781",
  "pulse": "static-1.1210",
  "quartz-config": "static-1.1543",
  "quartz-routing": "static-1.1195",
  "quick-fetch": "static-1.4267",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17281",
  "rpc-client-utils": "static-1.5206",
  "sanitize-text": "static-1.8698",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.69",
  "ui-addon-draggable": "static-3.5292",
  "ui-addon-react-router-dom": "static-1.10069",
  "usage-tracker": "static-1.7885",
  "usage-tracker-anonymous": "static-1.6302",
  "usage-tracker-core": "static-1.7735",
  "video-components-external": "static-1.12559",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.6102",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4042",
  "quartz-webpack": "static-1.3989",
  "bend-plugin-quartz-routing": "static-1.843",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5013",
  "icons": "static-2.717",
  "StyleGuideUI": "static-3.521",
  "trellis-components": "static-1.3289",
  "trellis-migration-context": "static-1.119",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.96",
  "customer-data-objects": "static-1.8256",
  "frontend-preferences-client": "static-1.8463",
  "laboratory-lib": "static-3.7690",
  "onboarding-scopes": "static-1.6992",
  "seat-types-lib": "static-1.1178",
  "ui-addon-opt": "static-4.8978",
  "HeadJS": "static-2.838",
  "hs-test-utils-bend-plugin": "static-1.3694",
  "msw": "static-1.106",
  "msw-config": "static-1.44",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.443",
  "ts-schema": "static-1.4433",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8508",
  "content-media-capture": "static-1.5895",
  "cssUtils": "static-1.1163",
  "customer-data-ui-utilities": "static-1.10374",
  "file-manager-components": "static-1.24942",
  "HubStyle": "static-2.12337",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3417",
  "react-input-autosize": "static-2.17",
  "ui-addon-emoji-picker": "static-1.10405",
  "ui-addon-i18n": "static-1.11688",
  "ui-business-units-lib": "static-1.9636",
  "ui-shepherd-react": "static-3.10828",
  "video-data-lib": "static-1.36217",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4845",
  "commerce-tours-lib": "static-1.6954",
  "customer-data-properties": "static-1.53258",
  "getting-started-shared-tasks": "static-1.19669",
  "growth-onboarding-reliability": "static-1.5623",
  "onboarding-tours": "static-1.17487",
  "reference-resolvers-lite": "static-1.8653",
  "sales-checkout-service-client": "static-1.4062",
  "ui-addon-iframeable": "static-1.9620",
  "user-context": "static-1.5598",
  "bender-build-tools": "static-1.3648",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.620",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.715",
  "quartz-auth": "static-1.1440",
  "quartz-head": "static-1.1430",
  "quartz-test": "static-1.1440",
  "quartz-tracking": "static-1.1144",
  "ui-fonts": "static-1.1292",
  "usage-tracker-container": "static-1.7875",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9965",
  "data-token-picker": "static-1.17228",
  "FileManagerLib": "static-1.40582",
  "property-translator": "static-1.5916",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6724",
  "SharedI18nStrings": "static-1.191",
  "foundations-components-test-utils": "static-1.6336",
  "react-create-root-preference": "static-1.123",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "ui-images": "static-2.1297",
  "bend-plugin-foundations-components": "static-1.5122",
  "floating-ui": "static-1.71",
  "react-aria": "static-1.80",
  "trellis-assets": "static-1.3270",
  "bend-plugin-foundations-theming": "static-1.3524",
  "foundations-theming-base": "static-1.4026",
  "stylex": "static-1.49",
  "interframe": "static-3.5286",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6299",
  "batch-promise": "static-1.2092",
  "bend-plugin-pulse": "static-1.713",
  "chirp-fetch": "static-1.2440",
  "event-emitter": "static-1.1500",
  "fast-json-patch": "static-1.77",
  "immer": "static-1.107",
  "opentelemetry-fe-types": "static-1.340",
  "beacon-keepalive-queue": "static-1.243",
  "web-vitals": "static-1.22",
  "bend-plugin-chirp-manifest": "static-1.616",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5008",
  "react-flip-move": "static-1.86",
  "apollo-link-hub-http": "static-2.5130",
  "content-media-composition-data-lib": "static-1.13699",
  "content-media-compositions": "static-2.17706",
  "idb-keyval": "static-1.58",
  "immerable": "static-1.4685",
  "magpie-lib": "static-1.5964",
  "magpie-types": "static-1.5424",
  "media-bridge-lib": "static-1.19734",
  "sassPrefix": "static-1.428",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "trellis-theming": "static-1.1586",
  "inbound-db-properties-service-client": "static-1.4190",
  "superstore": "static-1.5295",
  "feedback-loader": "static-1.30153",
  "ai-components-ui-library": "static-1.10136",
  "ui-addon-video-player": "static-1.9162",
  "ui-coaching-tips": "static-1.29644",
  "ContentUtils": "static-1.69626",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4970",
  "react-dnd-compat": "static-1.5151",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2395",
  "copilot-toolkit": "static-1.12274",
  "poll-commands": "static-1.4017",
  "atom": "static-1.5614",
  "navigation-messaging": "static-1.8660",
  "redux-thunk": "static-2.88",
  "reference-resolvers": "static-1.8727",
  "commerce-products-lib": "static-1.11101",
  "crm-message-bus": "static-1.44263",
  "growth-data-modal": "static-1.6222",
  "hubspot-apollo-client": "static-1.5416",
  "onboarding-tours-client": "static-1.5702",
  "calling-global-api": "static-1.66528",
  "calling-internal-common": "static-1.31864",
  "calling-lifecycle-internal": "static-1.67910",
  "calling-lifecycle-messages": "static-1.60202",
  "conditional-properties-service-client": "static-1.4151",
  "crm-index-visualization-core": "static-1.4853",
  "crm-links": "static-1.6868",
  "crm-pipelines-api-client-types": "static-1.4484",
  "customer-data-objects-ui-components": "static-1.13576",
  "customer-data-properties-shared-msw-handlers": "static-1.10336",
  "customer-data-property-utils": "static-1.8600",
  "data-agent-utils": "static-1.1071",
  "external-options-client-types": "static-1.4478",
  "formula-editor": "static-1.15087",
  "google-libphonenumber": "static-1.53",
  "hs-resources": "static-1.737",
  "inbound-db-meta-service-client": "static-1.3810",
  "inbounddb-objects-service-types": "static-1.4555",
  "meetings-icalendar-utils-lib": "static-1.1176",
  "multi-currency-client-types": "static-1.4049",
  "object-builder-ui-client": "static-1.50228",
  "pipeline-validation-client-types": "static-1.4322",
  "property-value-citations": "static-1.3872",
  "react-tinymce": "static-1.56381",
  "smart-data-capture-core": "static-1.622",
  "tiered-pricing": "static-1.2392",
  "tinymce-config": "static-2.55507",
  "tinymce-plugins": "static-1.58621",
  "tinymce-themes": "static-1.57477",
  "topics-actions-lib": "static-1.734",
  "trellis-ext-i18n": "static-1.1484",
  "trial-components-library": "static-1.14487",
  "ui-addon-form-validation": "static-1.11353",
  "zustand": "static-1.93",
  "growth-onboarding-confetti": "static-1.3597",
  "growth-onboarding-next-action-utils": "static-1.3105",
  "navigation-components": "static-1.19333",
  "nest": "static-1.780",
  "onboarding-tours-utils": "static-1.1554",
  "ui-shepherd-tracker": "static-1.8209",
  "ui-universal-auth": "static-1.9869",
  "getting-started-shared-tasks-store": "static-1.18787",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11007",
  "usage-tracker-session-replay": "static-1.5571",
  "audio-components": "static-1.6655",
  "FileManagerCore": "static-1.40441",
  "FileManagerImages": "static-1.38093",
  "video-components": "static-1.14561",
  "foundations-components-legacy": "static-1.1878",
  "purchase-motions-api": "static-1.6727",
  "signup-constants": "static-1.20123",
  "signup-ui-url-generator": "static-2.8576",
  "stylex-utils": "static-1.192",
  "usage-tracker-public": "static-1.7696",
  "reactive-lib": "static-1.1263",
  "simple-logging-lib": "static-1.3588",
  "nudge-client-utils": "static-1.3517",
  "chatspot-core": "static-1.24295",
  "growth-onboarding-feedback-components": "static-1.7125",
  "cms-field-types": "static-1.5353",
  "content-icons-ui": "static-1.2524",
  "integrations-lib": "static-1.17568",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1373",
  "breeze-engine-core": "static-1.1673",
  "highlight.js": "static-1.93",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30970",
  "commerce-permissions": "static-1.1323",
  "customer-data-tracking": "static-1.7411",
  "products-iframe-lib": "static-1.9062",
  "products-ui-components-shared-msw-handlers": "static-1.11391",
  "onboarding-data-sync-lib": "static-1.2927",
  "hubspot-apollo-cache": "static-1.875",
  "calling-error-reporting": "static-1.31871",
  "shared-worker-versioning": "static-1.11581",
  "calling-usage-tracker": "static-1.7082",
  "conversations-skeleton-state": "static-1.7653",
  "voice-sms-access-library": "static-1.2620",
  "crm-index-associations-lib": "static-1.6991",
  "redux-toolkit": "static-1.85",
  "sales-views-client-types": "static-1.4799",
  "location-customization-utils-lib": "static-1.10565",
  "data-agent-kit": "static-1.1058",
  "enrichment-settings-lib": "static-1.417",
  "fsm": "static-1.4301",
  "policy-lib": "static-1.7344",
  "bark-lib": "static-1.17075",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6437",
  "react-codemirror": "static-1.11182",
  "fdsr-migration-layer": "static-1.555",
  "framework-builder-read-service-client": "static-1.4374",
  "upgrade-components-lib": "static-1.798",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3570",
  "tinymce-data": "static-1.41592",
  "ui-addon-sales-email": "static-1.5748",
  "layout-dnd-components": "static-1.13324",
  "layout-dnd-utils": "static-1.12299",
  "ui-brand-identity-lib": "static-1.17106",
  "NamespacedHubStyle": "static-2.9408",
  "embedded-academy-lib": "static-1.16223",
  "hubs-service-types": "static-1.1807",
  "salesImages": "static-1.798",
  "growth-onboarding-next-action-components": "static-1.3133",
  "user-context-client": "static-1.5047",
  "custom-vendor-connection-lib": "static-1.433",
  "unified-auth-core-lib": "static-1.1665",
  "amplitude-session-replay-browser": "static-1.80",
  "breeze-artifacts-sdk": "static-1.1224",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.68",
  "urlinator": "static-1.5058",
  "video-embed": "static-1.37051",
  "social-insights-client-types": "static-1.23051",
  "nudge-custom-function-registry": "static-1.3274",
  "nudge-renderer-utils": "static-1.3593",
  "whisper-core-api": "static-1.7746",
  "flux-actions": "static-1.384",
  "integrations-error-boundary-lib": "static-1.14983",
  "integrations-tracking-lib": "static-1.6169",
  "native-integrations-shared-strings": "static-1.8299",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10912",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15963",
  "meetings-connect-utils-lib": "static-1.8160",
  "calling-orchestration-schema": "static-1.37397",
  "crm-record-cards-service-types": "static-1.3896",
  "highcharts": "static-8.118",
  "trellis-story-utils": "static-1.5036",
  "storybook-react": "static-1.47",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16778",
  "browser-eslint": "static-2.57",
  "persist-promise": "static-1.4249",
  "ContentData": "static-1.69701",
  "layout-data-lib": "static-1.10624",
  "academy-common-lib": "static-1.15684",
  "outpost": "static-1.4665",
  "universal-page-editor-lib": "static-1.3561",
  "advanced-menus-core": "static-1.15914",
  "advanced-menus-lib": "static-1.12642",
  "ExportDialog": "static-6.10914",
  "ui-memberships-settings-lib": "static-1.35336",
  "academy-service-client": "static-1.4234",
  "croppie": "static-2.10",
  "final-form": "static-1.86",
  "SafeStorage": "static-1.4935",
  "trellis-ecosystem": "static-1.7942",
  "crm-record-cards-client": "static-1.238",
  "framework-data-schema-resolvers": "static-1.7432",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15913",
  "simple-menus-lib": "static-1.17430",
  "settings-ui-lib": "static-1.13072",
  "marketplace-ui-apps-core": "static-1.19696",
  "marketplace-ui-common": "static-1.21164",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "developer-experience-shared-components": "static-1.11086",
  "immutable-less": "static-1.5188",
  "marketplace-ui-client-types": "static-1.18571",
  "ui-addon-integrations-directory-panel": "static-2.8490",
  "ui-extensibility-client-types": "static-1.4458",
  "ai-settings-ui-library": "static-1.8691",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1819",
  "apps-service-types": "static-1.4148",
  "oauth-service-types": "static-1.4677",
  "simple-data-table": "static-1.3946"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3565",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "avatar-components": "/avatar-components/static-1.3028",
  "client-types": "/client-types/static-1.524",
  "data-fetching-client": "/data-fetching-client/static-1.10176",
  "emoji-mart": "/emoji-mart/static-3.10",
  "enviro": "/enviro/static-4.529",
  "growth-payments-core": "/growth-payments-core/static-1.26635",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6132",
  "hs-test-utils": "/hs-test-utils/static-1.8583",
  "hub-http": "/hub-http/static-1.6745",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11009",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19409",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12030",
  "I18n": "/I18n/static-7.1725",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6998",
  "payment-link-components": "/payment-link-components/static-1.24593",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.30",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7765",
  "quartz-core": "/quartz-core/static-1.6984",
  "quartz-i18n": "/quartz-i18n/static-1.1440",
  "react": "/react/static-7.206",
  "react-colorpicker": "/react-colorpicker/static-2.10749",
  "react-dlb": "/react-dlb/static-1.97",
  "react-utils": "/react-utils/static-2.5719",
  "reselect": "/reselect/static-3.20",
  "rich-text-lib": "/rich-text-lib/static-1.20650",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18611",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6167",
  "UIComponents": "/UIComponents/static-3.8976",
  "video-player-core": "/video-player-core/static-1.24",
  "foundations-assets": "/foundations-assets/static-1.5430",
  "foundations-components": "/foundations-components/static-1.8853",
  "foundations-theming": "/foundations-theming/static-1.5041",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2757",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "portals-platform-lib": "/portals-platform-lib/static-1.1781",
  "pulse": "/pulse/static-1.1210",
  "quartz-config": "/quartz-config/static-1.1543",
  "quartz-routing": "/quartz-routing/static-1.1195",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17281",
  "rpc-client-utils": "/rpc-client-utils/static-1.5206",
  "sanitize-text": "/sanitize-text/static-1.8698",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.69",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5292",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10069",
  "usage-tracker": "/usage-tracker/static-1.7885",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6302",
  "usage-tracker-core": "/usage-tracker-core/static-1.7735",
  "video-components-external": "/video-components-external/static-1.12559",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4042",
  "quartz-webpack": "/quartz-webpack/static-1.3989",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.843",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "icons": "/icons/static-2.717",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "trellis-components": "/trellis-components/static-1.3289",
  "trellis-migration-context": "/trellis-migration-context/static-1.119",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.96",
  "customer-data-objects": "/customer-data-objects/static-1.8256",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8463",
  "laboratory-lib": "/laboratory-lib/static-3.7690",
  "onboarding-scopes": "/onboarding-scopes/static-1.6992",
  "seat-types-lib": "/seat-types-lib/static-1.1178",
  "ui-addon-opt": "/ui-addon-opt/static-4.8978",
  "HeadJS": "/HeadJS/static-2.838",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3694",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.44",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.443",
  "ts-schema": "/ts-schema/static-1.4433",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8508",
  "content-media-capture": "/content-media-capture/static-1.5895",
  "cssUtils": "/cssUtils/static-1.1163",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10374",
  "file-manager-components": "/file-manager-components/static-1.24942",
  "HubStyle": "/HubStyle/static-2.12337",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3417",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10405",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11688",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9636",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10828",
  "video-data-lib": "/video-data-lib/static-1.36217",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4845",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6954",
  "customer-data-properties": "/customer-data-properties/static-1.53258",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19669",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5623",
  "onboarding-tours": "/onboarding-tours/static-1.17487",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8653",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4062",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9620",
  "user-context": "/user-context/static-1.5598",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.620",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.715",
  "quartz-auth": "/quartz-auth/static-1.1440",
  "quartz-head": "/quartz-head/static-1.1430",
  "quartz-test": "/quartz-test/static-1.1440",
  "quartz-tracking": "/quartz-tracking/static-1.1144",
  "ui-fonts": "/ui-fonts/static-1.1292",
  "usage-tracker-container": "/usage-tracker-container/static-1.7875",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9965",
  "data-token-picker": "/data-token-picker/static-1.17228",
  "FileManagerLib": "/FileManagerLib/static-1.40582",
  "property-translator": "/property-translator/static-1.5916",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6724",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6336",
  "react-create-root-preference": "/react-create-root-preference/static-1.123",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "ui-images": "/ui-images/static-2.1297",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5122",
  "floating-ui": "/floating-ui/static-1.71",
  "react-aria": "/react-aria/static-1.80",
  "trellis-assets": "/trellis-assets/static-1.3270",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3524",
  "foundations-theming-base": "/foundations-theming-base/static-1.4026",
  "stylex": "/stylex/static-1.49",
  "interframe": "/interframe/static-3.5286",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6299",
  "batch-promise": "/batch-promise/static-1.2092",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.713",
  "chirp-fetch": "/chirp-fetch/static-1.2440",
  "event-emitter": "/event-emitter/static-1.1500",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "immer": "/immer/static-1.107",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.340",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.243",
  "web-vitals": "/web-vitals/static-1.22",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.616",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5008",
  "react-flip-move": "/react-flip-move/static-1.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5130",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13699",
  "content-media-compositions": "/content-media-compositions/static-2.17706",
  "idb-keyval": "/idb-keyval/static-1.58",
  "immerable": "/immerable/static-1.4685",
  "magpie-lib": "/magpie-lib/static-1.5964",
  "magpie-types": "/magpie-types/static-1.5424",
  "media-bridge-lib": "/media-bridge-lib/static-1.19734",
  "sassPrefix": "/sassPrefix/static-1.428",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "trellis-theming": "/trellis-theming/static-1.1586",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "superstore": "/superstore/static-1.5295",
  "feedback-loader": "/feedback-loader/static-1.30153",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10136",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9162",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29644",
  "ContentUtils": "/ContentUtils/static-1.69626",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4970",
  "react-dnd-compat": "/react-dnd-compat/static-1.5151",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2395",
  "copilot-toolkit": "/copilot-toolkit/static-1.12274",
  "poll-commands": "/poll-commands/static-1.4017",
  "atom": "/atom/static-1.5614",
  "navigation-messaging": "/navigation-messaging/static-1.8660",
  "redux-thunk": "/redux-thunk/static-2.88",
  "reference-resolvers": "/reference-resolvers/static-1.8727",
  "commerce-products-lib": "/commerce-products-lib/static-1.11101",
  "crm-message-bus": "/crm-message-bus/static-1.44263",
  "growth-data-modal": "/growth-data-modal/static-1.6222",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5416",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5702",
  "calling-global-api": "/calling-global-api/static-1.66528",
  "calling-internal-common": "/calling-internal-common/static-1.31864",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67910",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60202",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4151",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4853",
  "crm-links": "/crm-links/static-1.6868",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13576",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10336",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8600",
  "data-agent-utils": "/data-agent-utils/static-1.1071",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "formula-editor": "/formula-editor/static-1.15087",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "hs-resources": "/hs-resources/static-1.737",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4555",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1176",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50228",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4322",
  "property-value-citations": "/property-value-citations/static-1.3872",
  "react-tinymce": "/react-tinymce/static-1.56381",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.622",
  "tiered-pricing": "/tiered-pricing/static-1.2392",
  "tinymce-config": "/tinymce-config/static-2.55507",
  "tinymce-plugins": "/tinymce-plugins/static-1.58621",
  "tinymce-themes": "/tinymce-themes/static-1.57477",
  "topics-actions-lib": "/topics-actions-lib/static-1.734",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1484",
  "trial-components-library": "/trial-components-library/static-1.14487",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "zustand": "/zustand/static-1.93",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3597",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3105",
  "navigation-components": "/navigation-components/static-1.19333",
  "nest": "/nest/static-1.780",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1554",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8209",
  "ui-universal-auth": "/ui-universal-auth/static-1.9869",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18787",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11007",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5571",
  "audio-components": "/audio-components/static-1.6655",
  "FileManagerCore": "/FileManagerCore/static-1.40441",
  "FileManagerImages": "/FileManagerImages/static-1.38093",
  "video-components": "/video-components/static-1.14561",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1878",
  "purchase-motions-api": "/purchase-motions-api/static-1.6727",
  "signup-constants": "/signup-constants/static-1.20123",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8576",
  "stylex-utils": "/stylex-utils/static-1.192",
  "usage-tracker-public": "/usage-tracker-public/static-1.7696",
  "reactive-lib": "/reactive-lib/static-1.1263",
  "simple-logging-lib": "/simple-logging-lib/static-1.3588",
  "nudge-client-utils": "/nudge-client-utils/static-1.3517",
  "chatspot-core": "/chatspot-core/static-1.24295",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7125",
  "cms-field-types": "/cms-field-types/static-1.5353",
  "content-icons-ui": "/content-icons-ui/static-1.2524",
  "integrations-lib": "/integrations-lib/static-1.17568",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1373",
  "breeze-engine-core": "/breeze-engine-core/static-1.1673",
  "highlight.js": "/highlight.js/static-1.93",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30970",
  "commerce-permissions": "/commerce-permissions/static-1.1323",
  "customer-data-tracking": "/customer-data-tracking/static-1.7411",
  "products-iframe-lib": "/products-iframe-lib/static-1.9062",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11391",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2927",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.875",
  "calling-error-reporting": "/calling-error-reporting/static-1.31871",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11581",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7082",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7653",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2620",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6991",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "sales-views-client-types": "/sales-views-client-types/static-1.4799",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "data-agent-kit": "/data-agent-kit/static-1.1058",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.417",
  "fsm": "/fsm/static-1.4301",
  "policy-lib": "/policy-lib/static-1.7344",
  "bark-lib": "/bark-lib/static-1.17075",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6437",
  "react-codemirror": "/react-codemirror/static-1.11182",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.555",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.798",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3570",
  "tinymce-data": "/tinymce-data/static-1.41592",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5748",
  "layout-dnd-components": "/layout-dnd-components/static-1.13324",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12299",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17106",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9408",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16223",
  "hubs-service-types": "/hubs-service-types/static-1.1807",
  "salesImages": "/salesImages/static-1.798",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3133",
  "user-context-client": "/user-context-client/static-1.5047",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.433",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1665",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1224",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.68",
  "urlinator": "/urlinator/static-1.5058",
  "video-embed": "/video-embed/static-1.37051",
  "social-insights-client-types": "/social-insights-client-types/static-1.23051",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3274",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3593",
  "whisper-core-api": "/whisper-core-api/static-1.7746",
  "flux-actions": "/flux-actions/static-1.384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14983",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6169",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8299",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10912",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15963",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8160",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37397",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3896",
  "highcharts": "/highcharts/static-8.118",
  "trellis-story-utils": "/trellis-story-utils/static-1.5036",
  "storybook-react": "/storybook-react/static-1.47",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16778",
  "browser-eslint": "/browser-eslint/static-2.57",
  "persist-promise": "/persist-promise/static-1.4249",
  "ContentData": "/ContentData/static-1.69701",
  "layout-data-lib": "/layout-data-lib/static-1.10624",
  "academy-common-lib": "/academy-common-lib/static-1.15684",
  "outpost": "/outpost/static-1.4665",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3561",
  "advanced-menus-core": "/advanced-menus-core/static-1.15914",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12642",
  "ExportDialog": "/ExportDialog/static-6.10914",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35336",
  "academy-service-client": "/academy-service-client/static-1.4234",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.86",
  "SafeStorage": "/SafeStorage/static-1.4935",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7942",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.238",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15913",
  "simple-menus-lib": "/simple-menus-lib/static-1.17430",
  "settings-ui-lib": "/settings-ui-lib/static-1.13072",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19696",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21164",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11086",
  "immutable-less": "/immutable-less/static-1.5188",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18571",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8490",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4458",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8691",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1819",
  "apps-service-types": "/apps-service-types/static-1.4148",
  "oauth-service-types": "/oauth-service-types/static-1.4677",
  "simple-data-table": "/simple-data-table/static-1.3946"
}
};
